import type { Permission } from '@letsdial/api/src/lib/types/User'

export function hasInterfacePermission(
  isStaff: boolean,
  permissions: Permission[],
  action: string,
  subject: string,
): boolean {
  if (isStaff) {
    return true
  }

  return permissions.some(
    (permission) =>
      permission.action === action &&
      (permission.subject === subject || permission.subject === 'all'),
  )
}
